import { render, staticRenderFns } from "./NoticeTable.vue?vue&type=template&id=90e8335e&scoped=true&"
import script from "./NoticeTable.vue?vue&type=script&lang=js&"
export * from "./NoticeTable.vue?vue&type=script&lang=js&"
import style0 from "./NoticeTable.vue?vue&type=style&index=0&id=90e8335e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e8335e",
  null
  
)

export default component.exports